var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import { css } from '@patternfly/react-styles';
import PropTypes from 'prop-types';
import styles from '../../@patternfly/patternfly-next/components/ModalBox/modal-box.css.js';
import { Button } from '../Button';
import TimesIcon from '@patternfly/react-icons/dist/esm/icons/times-icon';


var propTypes = {
  /** additional classes added to the close button */
  className: PropTypes.string,
  /** A callback for when the close button is clicked */
  onClose: PropTypes.func
};

var defaultProps = {
  className: '',
  onClose: function onClose() {
    return undefined;
  }
};

var ModalBoxCloseButton = function ModalBoxCloseButton(_ref) {
  var className = _ref.className,
      onClose = _ref.onClose,
      props = _objectWithoutProperties(_ref, ['className', 'onClose']);

  return React.createElement(
    'div',
    _extends({}, props, { className: css(styles.modalBoxClose, className) }),
    React.createElement(
      Button,
      { variant: 'plain', onClick: onClose, 'aria-label': 'Close' },
      React.createElement(TimesIcon, null)
    )
  );
};

ModalBoxCloseButton.propTypes = propTypes;
ModalBoxCloseButton.defaultProps = defaultProps;

export default ModalBoxCloseButton;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-core/dist/esm/components/Modal/ModalBoxCloseButton.js
// module id = 117
// module chunks = 0